(() => {
  'use strict';

  function start() {
    const opener = document.querySelector('.custom-chat-opener');
    const menuButton = document.querySelector('.custom-chat-open-button');
    const messageButton = document.querySelector('.custom-chat-message-button');
    const purchaseDrawerSelector = 'cart-drawer, addons-drawer';
    let widget;
    let attempts = 0;

    const isPurchaseContext = () => document.body.classList.contains('cart-template')
      || Boolean(document.querySelector('cart-drawer[open], addons-drawer[open]'));

    function minimiseChat() {
      if (!widget) return;
      widget.call('hide_greeting');
      widget.call('minimize');
      menuButton?.setAttribute('data-open', 'false');
      menuButton?.setAttribute('aria-expanded', 'false');
    }

    function toggleMenu() {
      const expanded = menuButton.getAttribute('data-open') !== 'true';
      menuButton.setAttribute('data-open', String(expanded));
      menuButton.setAttribute('aria-expanded', String(expanded));
    }

    function bindButton(button, action) {
      if (!button) return;
      button.addEventListener('click', action);
      button.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          action();
        }
      });
    }

    function connect() {
      const api = window.LiveChatWidget;
      if (!api || typeof api.on !== 'function' || typeof api.call !== 'function') {
        // The app loads independently of the theme. Do not install it again.
        if (++attempts < 120) window.setTimeout(connect, 250);
        return;
      }
      widget = api;

      widget.on('ready', () => {
        opener?.classList.remove('hidden');
        if (isPurchaseContext()) minimiseChat();
      });
      widget.on('greeting_displayed', () => {
        if (isPurchaseContext()) widget.call('hide_greeting');
      });

      bindButton(menuButton, toggleMenu);
      bindButton(messageButton, () => {
        widget.call('maximize');
        menuButton?.setAttribute('data-open', 'false');
        menuButton?.setAttribute('aria-expanded', 'false');
      });

      // Theme drawers dispatch this event immediately after their open state changes.
      document.addEventListener('toggle', (event) => {
        if (event.target.matches?.(purchaseDrawerSelector) && event.target.hasAttribute('open')) {
          minimiseChat();
        }
      });
    }

    connect();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
